
import { connect } from 'react-redux';
import { NewPassword } from "./new-password";
import {setError, setPasswordFromSession} from "../login/actions";

const mapDispatchToProps = dispatch => {
  return {
    setError: error => dispatch(setError(error)),
    setPasswordFromSession: (password) => dispatch(setPasswordFromSession(password)),
  }
};

const mapStateToProps = state => {
  return {
    app: state.app,
    client: state.client,
    wlf_id: state.app.wlf.id,
    identity_pool_index: state.app.wlf.identity_pool_index,
    user: state.user,
    dwolla: state.dwolla,
    onboarding: state.onboarding,
    config: state.app.config,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPassword);
